import { reactive, readonly } from 'vue';

export class ErrorService {
	private state = reactive({
		showErrorModal: false,
		lastErrorMessage: '',
		criticalError: null as Error | null
	});

	get errorState() {
		return readonly(this.state);
	}

	showError(error: Error | string | any) {
		this.state.lastErrorMessage = error instanceof Error ? error.message : String(error);
		this.state.criticalError = error instanceof Error ? error : new Error(String(error));
		this.state.showErrorModal = true;
	}

	clearError() {
		this.state.showErrorModal = false;
		this.state.lastErrorMessage = '';
		this.state.criticalError = null;
	}
}

// Создаем экземпляр сервиса для глобального доступа
export const errorService = new ErrorService();